import {
  pedidoAbertoERP,
  pedidoAprovado,
  pedidoCancelado,
  pedidoConfirmado,
  pedidoConfirmandoERP,
  pedidoEmAnalise,
  pedidoFaturado,
  pedidoFaturadoParcial,
  pedidoNaoConfirmado,
  pedidoNaoLiberado,
  pedidoProducao,
  pedidoReprovado,
  pedidoStatusOutro,
} from '../../../../home/pedido/status/pedido-status';
import { IStatus } from './novo-pedido-status-multi-select.component';

export const getStatusConfig = (status: IStatus) => [
  {
    status: pedidoNaoConfirmado,
    show: status.hasNaoConfirmado,
    cssClass: 'status__nao-confirmado',
  },
  {
    status: pedidoNaoLiberado,
    show: status.hasNaoLiberado,
    cssClass: 'status__nao-liberado',
  },
  {
    status: pedidoConfirmado,
    show: status.hasConfirmado,
    cssClass: 'status__confirmado',
  },
  {
    status: pedidoConfirmandoERP,
    show: status.hasConfirmandoERP,
    cssClass: 'status__confirmando-erp',
  },
  {
    status: pedidoAbertoERP,
    show: status.hasAbertoERP,
    cssClass: 'status__aberto-erp',
  },
  {
    status: pedidoEmAnalise,
    show: status.hasEmAnalise,
    cssClass: 'status__em-analise',
  },
  {
    status: pedidoAprovado,
    show: status.hasAprovado,
    cssClass: 'status__aprovado',
  },
  {
    status: pedidoReprovado,
    show: status.hasReprovado,
    cssClass: 'status__reprovado',
  },
  {
    status: pedidoProducao,
    show: status.hasProducao,
    cssClass: 'status__producao',
  },
  {
    status: pedidoFaturado,
    show: status.hasFaturado,
    cssClass: 'status__faturado',
  },
  {
    status: pedidoFaturadoParcial,
    show: status.hasFaturadoParcial,
    cssClass: 'status__faturado-parcial',
  },
  {
    status: pedidoCancelado,
    show: status.hasCancelado,
    cssClass: 'status__cancelado',
  },
  {
    status: pedidoStatusOutro,
    show: status.hasOutro,
    cssClass: 'status__outro',
  },
];
